import React, { useContext } from "react";
import bgDesktop from "images/kosmofi/bg-desktop.svg";
import bgMobile from "images/kosmofi/bg-mobile.svg";
import { BreakpointContext } from "components/common";
import KosmofiHeader from "./Header";
import LandingForm from "./LandingForm";

const KosmofiLanding = () => {
  const { isBelow } = useContext(BreakpointContext);
  let cardHeight = 0;
  if (isBelow("md")) {
    cardHeight = 190;
  } else {
    cardHeight = 290;
  }
  return (
    <div className="flex flex-col min-h-screen h-full lg:overflow-hidden pb-4 lg:pb-0" style={{ backgroundColor: "#F8F8F8" }}>
      <KosmofiHeader />
      <div className="relative flex flex-col pt-8 md:pt-16 lg:pt-0 lg:flex-row-reverse h-full items-start justify-start">
        <img
          src={bgDesktop}
          alt="Kosmofi Background"
          className="hidden lg:block h-screen"
        />
        <img
          src={bgMobile}
          alt="Kosmofi Background"
          className="block lg:hidden w-full transition-all duration-300 ease-in-out"
          style={{ height: cardHeight }}
        />
        <div className="flex lg:self-center w-full justify-center mt-8 md:mt-12 px-6 lg:mt-0 lg:justify-start lg:pl-24 lg:items-center">
          <LandingForm />
        </div>
      </div>
    </div>
  );
};

export default KosmofiLanding;
